import { Injectable } from '@angular/core';

import {MyCONST} from '../CONST/myCONST';
import {Socket, SocketIoConfig} from 'ngx-socket-io';
import {UrlService} from './url.service';
import {EnvService} from './env.service';
import {Observable} from 'rxjs';
import {emit} from 'cluster';

@Injectable({
  providedIn: 'root'
})
export class USSDGWSimulatorService {

  ussdgw_simulator: Socket;
  connected = false;

  constructor(private url: UrlService, private env: EnvService) {

  }

  ussdgw_simulator_connect() {

    if (!this.env.ussdgw_socket_connected) {
      console.log('Service: rrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr');
      return;
    }
    console.log('Service : iiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiii');
    const url = this.url.socket_url;
    const query = 'phone_number=1122334455667&imei=00000000000000' ;
    const config: SocketIoConfig = { url: url + '/ussd', options: {query: query,
        autoConnect: true,
        reconnection: true,
        reconnectionDelay: 1000,
        reconnectionDelayMax : 5000,
        reconnectionAttempts: 10,
        transports: ['polling', 'websocket']} };

    const token = localStorage.getItem(MyCONST.Token);
    this.ussdgw_simulator = new Socket(config);
    /*this.ussdgw_simulator = new Socket({
      url: url + 'ussdgw?token=' + token, options: {
        transport: ['websocket']
      }
    });*/
    this.ussdgw_simulator.connect();
    this.connected = true;
  }

  listen(eventName: string){
    return new Observable((subscriber) => {
      this.ussdgw_simulator.on(eventName, (data) => {
        subscriber.next(data);
      })
    });
  }j
  emit(eventName: string, data: any) {
    this.ussdgw_simulator.emit(eventName, data);
  }
}
